module.exports = __webpack_public_path__ + "static/img/bg3.3bf0277.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg3.jpg
// module id = 6xA4
// module chunks = 1